import { ref } from "vue";

export default function useUpdateSW() {
  const refreshing = ref<boolean>(false);
  const registration = ref<ServiceWorkerRegistration | null>(null);
  const updateExists = ref<boolean>(false);


  const updateAvailable = (event: CustomEvent<ServiceWorkerRegistration>) => {
    registration.value = event.detail;
    updateExists.value = true;
  }

  const refreshApp = () => {
    updateExists.value = false;
    // Make sure we only send a 'skip waiting' message if the SW is waiting
    if (!registration.value || !registration.value.waiting) {
      return
    } else {
      // send message to SW to skip the waiting and activate the new SW
      registration.value.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }

  const handleControllerChange = () => {
    // Prevent multiple refreshes
    if (refreshing.value) {
      return
    } else {
      refreshing.value = true;
      // Here the actual reload of the page occurs
      window.location.reload()
    }
  }

  // Listen for our custom event from the SW registration
  document.addEventListener('swUpdated', updateAvailable, { once: true })

  navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange)

  return { updateExists, refreshApp }
}